import { Box, Flex, Text } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-light-svg-icons';

export const AuthorEditModal = ({
  title,
  description,
  onClose,
  onConfirm
}: {
  title: string;
  description: string;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal isOpen onClose={onClose} width='448px'>
      <Flex padding={{ base: 6, md: 8 }} gap={4} flexDirection="column">
        <Box textAlign="center">
          <FontAwesomeIcon fontSize={32} icon={faExclamationTriangle} />
        </Box>
        <Text textStyle="headingGroup" textAlign="center">
          {title}
        </Text>
        <Text textAlign="center">{description}</Text>
        <Flex gap={2} flexDirection="column" marginTop={6}>
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button type="submit" onClick={onConfirm}>
            Edit
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
